module.exports = __webpack_public_path__ + "img/text-7.2cba83ef.png";